// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form[data-v-e946d654]{width:240px}form label[data-v-e946d654]{font-size:unset}form input[data-v-e946d654]{font-size:unset!important;height:34px}", ""]);
// Exports
module.exports = exports;
